import './panel.sass';

export { default } from './panel';
